const env = process.env.NODE_ENV || 'development';
const CONFIG = require('./config.' + env);

export default CONFIG;
